// @flow
import EntityTypeEnum from 'common/enums/EntityTypeEnum';

export const VolumeUnitEnum = new EntityTypeEnum({
    MetersCubic: 'METERS_CUBIC',
    ItemCount: 'ITEM_COUNT',
    TaskCount: 'TASK_COUNT'
});

export const volumeUnitOptions = VolumeUnitEnum.getOptions({
    translationKey: 'translations:volumeUnits'
});

export type VolumeUnitEnumType = 'METERS_CUBIC' | 'ITEM_COUNT' | 'TASK_COUNT';
